import type { Tenant, AllowedPage, TenantBot } from '@/types/dashboard';

/**
 * Compute default redirect path when user has access.
 * Priority: first tenant with pages → first page or /pages; else first tenant with bots → /bots; else /tenants.
 */
export function getDefaultRedirectPath(
  tenants: Tenant[],
  tenantPages: Record<string, AllowedPage[]>,
  tenantBots: Record<string, TenantBot[]>
): string {
  const keysWithPages = Object.keys(tenantPages).filter((id) => (tenantPages[id]?.length ?? 0) > 0);
  const keysWithBots = Object.keys(tenantBots || {}).filter((id) => (tenantBots?.[id]?.length ?? 0) > 0);

  if (keysWithPages.length > 0) {
    const tenant = tenants?.find((t) => t.id === keysWithPages[0]);
    if (tenant) {
      const pages = tenantPages[tenant.id] || [];
      if (pages.length === 1) {
        return `/${tenant.slug}/${pages[0].channel}/${pages[0].pageId}`;
      }
      return `/${tenant.slug}/pages`;
    }
  }

  if (keysWithBots.length > 0) {
    return '/bots';
  }

  return '/tenants';
}
